import { Controller, useFormContext } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import { AbsDropDown, Label, TextArea } from "abs-ui-components";
import { Input } from "abs-ui-components";
import PortCodeAutocomplete from "../../PortCodeAutoComplete";
import { useEffect } from "react";

const MainSectionForm = ({ section, type, formValues }) => {
	const {
		control,
		formState: { errors },
		clearErrors,
		setValue,
	} = useFormContext();

	useEffect(() => {
		const eventType = formValues.EVENTTYPE?.value;
		if (eventType !== "ARRIVAL" || eventType !== "DEPARTURE") {
			clearErrors("portCodeMstId");
		}
	}, [formValues.EVENTTYPE, clearErrors]);

	const transformOptions = (options = []) => {
		return options?.map((option) => ({
			label: option,
			value: option,
		}));
	};

	const portCodeChange = (obj) => {
		const portCodeMstId = obj?.portCodeMstId || null;
		setValue("portCodeMstId", portCodeMstId);
		if (portCodeMstId) {
			clearErrors("portCodeMstId");
		}
	};

	return (
		<div className="section-form">
			{section.sectionName === "Main Details" && (
				<>
				
					<MDBRow className="mt-3">
						{section?.fields
							?.filter(
								(formField) =>
									formField.fieldName !== "PURPOSE OF CALL"
							)
							?.map((formField, fieldIndex) => (
								<MDBCol
									md="4"
									key={`${formField.key}-${fieldIndex}`}
								>
									{formField.dataType === "date" && (
										<>
											<Label
												bold
												name={formField.fieldName}
												className="mb-1"
											/>

											<Controller
												name={formField.key}
												control={control}
												rules={{
													required:
														"Please enter a date",
												}}
												defaultValue={
													type === "Edit" &&
														dayjs(
															`${formField.value} GMT`
														).isValid()
														? dayjs(
															`${formField.value} GMT`
														)
														: null
												}
												render={({ field }) => (
													<LocalizationProvider
														dateAdapter={AdapterDayjs}
													>
														<DateTimePicker
															timezone="UTC"
															format="DD/MMM/YYYY hh:mm"
															label="Select Date Time"
															value={
																field.value ||
																null
															}
															onChange={(newValue) =>
																field.onChange(
																	newValue
																)
															}
															renderInput={(
																params
															) => (
																<Input
																	{...params}
																/>
															)}
														/>

														{errors[
															formField.key
														] && (
																<div className="pt-2 error">
																	{
																		errors[
																			formField
																				.key
																		]?.message
																	}
																</div>
															)}
													</LocalizationProvider>
												)}
											/>
										</>
									)}

									{formField.dataType === "AutoComplete" && (
										<>
											<Label
												bold
												name={formField.fieldName}
												className="mb-1"
											/>

											<Controller
												name="portCodeMstId"
												control={control}
												defaultValue={
													type === "Edit"
														? formField.value || null
														: ""
												}
												rules={{
													validate: (value) => {
														const eventType =
															formValues.EVENTTYPE
																?.value;

														if (
															(eventType ===
																"ARRIVAL" ||
																eventType ===
																"DEPARTURE") &&
															!value
														) {
															return "Please enter a valid port code for Arrival/Departure events";
														}

														return true;
													},
												}}
												render={({ field }) => (
													<>
														<PortCodeAutocomplete
															defaultPortCodeMstId={
																field?.value
															}
															setDefaultValue={(
																portCodeMstId
															) => {
																setValue(
																	"portCodeMstId",
																	portCodeMstId
																);
																clearErrors(
																	"portCodeMstId"
																);
															}}
															onValueChange={
																portCodeChange
															}
														/>

														{errors.portCodeMstId && (
															<div className="pt-2 error">
																{
																	errors
																		.portCodeMstId
																		.message
																}
															</div>
														)}
													</>
												)}
											/>
										</>
									)}

									{formField.dataType === "options" &&
										formField.key && (
											<>
												<Label
													bold
													name={
														formField.fieldName
													}
													className="mb-3"
												/>

												<Controller
													name={formField.key}
													control={control}
													defaultValue={
														type === "Edit"
															? {
																field: formField.value,
																value: formField.value,
															}
															: transformOptions(
																formField.options
															)[0]
													}
													render={({ field }) => (
														<AbsDropDown
															options={transformOptions(
																formField.options
															)}
															value={
																field?.value
															}
															selected={
																field?.value
																	?.value
															}
															placeholder="Select"
															handleChange={(e) =>
																field.onChange(e)
															}
														/>
													)}
												/>
											</>
										)}
								</MDBCol>
							))}
					</MDBRow>

			
					{section?.fields?.some(
						(formField) =>
							formField.fieldName === "PURPOSE OF CALL"
					) && (
							<MDBRow className="mt-4">
								{section?.fields
									?.filter(
										(formField) =>
											formField.fieldName ===
											"PURPOSE OF CALL"
									)
									?.map((formField, fieldIndex) => (
										<MDBCol
											md="4"
											key={`${formField.key}-${fieldIndex}`}
										>
											<Label
												bold
												name={formField.fieldName}
												className="mb-3"
											/>

											<Controller
												name={formField.key}
												control={control}
												defaultValue={
													type === "Edit"
														? {
															field: formField.value,
															value: formField.value,
														}
														: null
												}
												render={({ field }) => (
													<AbsDropDown
														options={[
																{ label: "Please Select", value: "" },
																...transformOptions(formField.options)
															]}
														value={field?.value}
														selected={
															field?.value?.value
														}
														placeholder="Select"
														handleChange={(e) =>
															field.onChange(e)
														}
													/>
												)}
											/>
										</MDBCol>
									))}
							</MDBRow>
						)}
				</>
			)}
			
		</div>
	);
};

export default MainSectionForm;
